import { AxiosResponse } from "axios";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";
import {
  authenticationApiUrls,
  MERCHANT_V3_API_URLS as M3_API,
} from "@/apps/merchant3/services/apiClient/apiUrl";
import { IncodeAuthVerifyPayload } from "@/types/IncodeAuthResult";

export interface IIncodeOnBoard {
  url: string;
}

export interface IIncodeStatus {
  completed: boolean;
  status: string;
}

export interface IIncodeAuthVerify {
  jwt?: string;
  code?: IncodeAuthVerifyCode;
}

export enum IncodeAuthVerifyCode {
  NOT_MATCH_CS_REVIEW = 10471,
}

export interface IIncodeImport {
  completed: boolean;
}

export interface IIncodeUpdateUuid {
  completed: boolean;
}

export const incodeOnBoard = async (
  cartTag: string
): Promise<AxiosResponse<IIncodeOnBoard>> => {
  return await jwtApiClient.get(M3_API(cartTag).INCODE_ONBOARD);
};

export const incodeStatus = async (
  cartTag: string
): Promise<AxiosResponse<IIncodeStatus>> => {
  return await jwtApiClient.get(M3_API(cartTag).INCODE_STATUS);
};

export const incodeStatusFrontCompleted = async (
  cartTag: string
): Promise<AxiosResponse<IIncodeStatus>> => {
  return await jwtApiClient.get(M3_API(cartTag).INCODE_STATUS_FRONT_COMPLETED);
};

export const incodeStatusFront = async (
  cartTag: string
): Promise<AxiosResponse<IIncodeStatus>> => {
  return await jwtApiClient.get(M3_API(cartTag).INCODE_STATUS_FRONT);
};

export const incodeAuthVerify = async (
  authData: IncodeAuthVerifyPayload
): Promise<AxiosResponse<IIncodeAuthVerify>> => {
  return await jwtApiClient.post(
    authenticationApiUrls.INCODE_AUTH_VERIFY,
    authData
  );
};

export const incodeImport = async (
  cartTag: string
): Promise<AxiosResponse<IIncodeImport>> => {
  return await jwtApiClient.post(M3_API(cartTag).INCODE_IMPORT);
};

export const incodeUpdateUuid = async (
  cartTag: string
): Promise<AxiosResponse<IIncodeImport>> => {
  return await jwtApiClient.post(M3_API(cartTag).INCODE_UPDATE_UUID);
};
